import React from 'react'
import BloomIntroSection from '../components/__SeasonTwo__/__Pages__/Landing/BloomIntroSection'
import SeasonTwoHighlightSection from '../components/__SeasonTwo__/__Pages__/Landing/SeasonTwoHighlightSection'
import BloomCollectionsSection from '../components/__SeasonTwo__/__Pages__/Landing/BloomCollectionsSection'
import ArticlesLandingSection from '../components/__SeasonTwo__/__Pages__/Articles/ArticlesLandingSection'
import BloomDisclaimer from '../components/__SeasonTwo__/__Pages__/Landing/BloomDisclaimer'
import { Meta } from '../components/Meta'

const Home = ({data}) => {
  data = data.allContentfulSiteGlobalData.edges[0].node;

  return (
    <div key="home">
      <Meta/>
      <BloomIntroSection data={data}/>
      <SeasonTwoHighlightSection data={data}/>
      <BloomCollectionsSection data={data}/>
      <ArticlesLandingSection data={data} images={data.v2ArticlesHomepageImages} isLinkOut/>
      <BloomDisclaimer/>
    </div>
  )
}

export default Home



export const pageQuery = graphql`
  query HomeV2Query {
    allContentfulSiteGlobalData(filter: { node_locale: { eq: "en-US" } }) {
      edges {
        node {
          mapViewArticleOrder {
            slug
          }
          introBloomImages {
            file {
              url
            }
          }
          introFlipImages {
            file {
              url
            }
          }
          introFlipImagesMobile {
            file {
              url
            }
          }
          introFullImage {
            file {
              url
            }
          }
          introMaskImage {
            file {
              url
            }
          }
          homePageBackgroundImages {
            resolutions {
              aspectRatio
            }
            file {
              url
            }
          }

          v2IntroText {
            v2IntroText
          }
          
          v2introHighlightedArticles {
            ... on ContentfulArticleV2 {
              title
              slug
              category
              listViewImage {
                file {
                  url
                }
              }
              sys {
                contentType {
                  sys {
                    id
                  }
                }
              }
            }
            ... on ContentfulArticle {
              title
              slug
              category
              listViewImage {
                file {
                  url
                }
              }
              sys {
                contentType {
                  sys {
                    id
                  }
                }
              }
            }


          }

          v2Season2HighlightBusiness {
            title
            slug
            category
            listViewImage {
              file {
                url
              }
            }
            sys {
              contentType {
                sys {
                  id
                }
              }
            }
          }

          v2Season2HighlightBeing {
            title
            slug
            category
            listViewImage {
              file {
                url
              }
            }
            sys {
              contentType {
                sys {
                  id
                }
              }
            }
          }

          v2Season2HighlightBeyond {
            title
            slug
            category
            listViewImage {
              file {
                url
              }
            }
            sys {
              contentType {
                sys {
                  id
                }
              }
            }
          }

          v2Season2IntroHeading {
            v2Season2IntroHeading
          }

          v2Season2IntroDescription {
            v2Season2IntroDescription
          }

          v2Season2BusinessHeading {
            v2Season2BusinessHeading
          }

          v2Season2BusinessDescription {
            v2Season2BusinessDescription
          }

          v2Season2BeingHeading {
            v2Season2BeingHeading
          }

          v2Season2BeingDescription {
            v2Season2BeingDescription
          }

          v2Season2BeyondHeading {
            v2Season2BeyondHeading
          }

          v2Season2BeyondDescription {
            v2Season2BeyondDescription
          }

          v2CollectionsHeading {
            v2CollectionsHeading
          }

          v2CollectionsDescription {
            v2CollectionsDescription
          }

          v2HighlightedCollections {
            tags {
              name
            }
            image {
              file {
                url
              }
            }
            name
          }


          v2ArticlesHomepageLinkHeading {
            v2ArticlesHomepageLinkHeading
          }

          v2ArticlesHomepageLinkCopy {
            v2ArticlesHomepageLinkCopy
          }


          v2ArticlesHomepageImages {
              file {
                  url
              }
          }
        }
      }
    }

  }
`
